import React from "react";
import { Bar, Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const students = {
  sectionA: [
    { name: "Aaryan Mehta", grade: 9 },
    { name: "Meera Iyer", grade: 9 },
    { name: "Trupti Salunke", grade: 7 },
    { name: "Rohan Shah", grade: 6 },
    { name: "Neha Gupta", grade: 8 },
    { name: "Karan Patel", grade: 5 },
    { name: "Sanya Verma", grade: 7 },
    { name: "Aditya Rao", grade: 6 },
    { name: "Ritika Joshi", grade: 5 },
    { name: "Vikas Menon", grade: 4 },
  ],
  sectionB: [
    { name: "Tanisha More", grade: 9 },
    { name: "Pooja Nair", grade: 9 },
    { name: "Rahul Shetty", grade: 7 },
    { name: "Sneha Kapoor", grade: 6 },
    { name: "Amit Dubey", grade: 8 },
    { name: "Priya Singh", grade: 5 },
    { name: "Manoj Kumar", grade: 7 },
    { name: "Devika Sen", grade: 6 },
    { name: "Nitin Roy", grade: 5 },
    { name: "Ananya Das", grade: 4 },
  ],
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: {
        font: { size: 10 },
      },
    },
    tooltip: {
      titleFont: { size: 10 },
      bodyFont: { size: 9 },
    },
  },
  scales: {
    x: {
      ticks: {
        font: { size: 10 },
      },
    },
    y: {
      ticks: {
        font: { size: 10 },
      },
    },
  },
};

const getChartData = (section) => ({
  labels: students[section].map((s) => s.name),
  datasets: [
    {
      label: "Grades",
      data: students[section].map((s) => s.grade),
      backgroundColor: "rgba(75, 192, 192, 0.6)",
      borderColor: "rgba(75, 192, 192, 1)",
      borderWidth: 1,
    },
  ],
});

const getPieChartData = () => {
  const gradeCounts = {};
  Object.values(students).flat().forEach(({ grade }) => {
    gradeCounts[grade] = (gradeCounts[grade] || 0) + 1;
  });

  return {
    labels: Object.keys(gradeCounts),
    datasets: [
      {
        data: Object.values(gradeCounts),
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50", "#9C27B0"],
      },
    ],
  };
};

const RubricGradingHub = () => {
  return (
    <div className="w-full p-5">
      <h2 className="text-xl font-bold mb-4">Science Rubric Dashboard</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-lg font-semibold">Section A - Grade Distribution</h3>
          <div style={{ height: "300px" }}>
            <Bar data={getChartData("sectionA")} options={chartOptions} />
          </div>
        </div>
        <div>
          <h3 className="text-lg font-semibold">Section B - Grade Distribution</h3>
          <div style={{ height: "300px" }}>
            <Bar data={getChartData("sectionB")} options={chartOptions} />
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h3 className="text-lg font-semibold">Overall Grade Trends</h3>
        <div style={{ height: "300px" }}>
          <Line data={getChartData("sectionA")} options={chartOptions} />
        </div>
      </div>
      <div className="mt-6">
        <h3 className="text-lg font-semibold">Grade Distribution Pie Chart</h3>
        <div style={{ height: "300px" }}>
          <Pie data={getPieChartData()} options={chartOptions} />
        </div>
      </div>
    </div>
  );
};

export default RubricGradingHub;
